import { render, staticRenderFns } from "./VoiceVisualizer.vue?vue&type=template&id=6b0c64f6&scoped=true&"
import script from "./VoiceVisualizer.vue?vue&type=script&lang=js&"
export * from "./VoiceVisualizer.vue?vue&type=script&lang=js&"
import style0 from "../components/css/Style.css?vue&type=style&index=0&id=6b0c64f6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0c64f6",
  null
  
)

export default component.exports